<div class="row">
  <div class="col-12">
    <lib-breadcrumb></lib-breadcrumb>
  </div>
</div>

<lib-filter-list #productList [configService]="productListConfigService"></lib-filter-list>
